function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "calcon-logo-color-f");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 199.99,
    height: 41.9,
    viewBox: "0 0 199.99 41.9"
  }, props), _ref, React.createElement("g", {
    id: "Logo"
  }, React.createElement("polygon", {
    points: "31.42 6.86 27.38 11.5 42.8 34.87 42.8 41.9 51.21 37.45 31.42 6.86",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("polygon", {
    points: "52.72 36.6 30.74 2.63 5.01 32.59 0 11.5 31.3 0 53.89 36.04 52.72 36.6",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("rect", {
    x: 26.53,
    y: 22.88,
    width: 5.3,
    height: 6.49,
    style: {
      "fill": "#345670"
    }
  }), React.createElement("rect", {
    x: 20.38,
    y: 22.88,
    width: 5.3,
    height: 6.49,
    style: {
      "fill": "#345670"
    }
  }), React.createElement("rect", {
    x: 26.53,
    y: 30.3,
    width: 5.3,
    height: 6.49,
    style: {
      "fill": "#345670"
    }
  }), React.createElement("rect", {
    x: 20.38,
    y: 30.3,
    width: 5.3,
    height: 6.49,
    style: {
      "fill": "#345670"
    }
  })), React.createElement("path", {
    d: "M72.84,23.1a13.64,13.64,0,0,1-5.45.92c-7.34,0-11.12-4.57-11.12-10.62,0-7.25,5.17-11.28,11.59-11.28a12.35,12.35,0,0,1,5.23.95l-1,3.8a10.53,10.53,0,0,0-4-.78c-3.81,0-6.77,2.3-6.77,7,0,4.25,2.52,6.93,6.8,6.93a11.92,11.92,0,0,0,4-.7Z",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("path", {
    d: "M85.87,23.7l-.29-1.55h-.09a5.56,5.56,0,0,1-4.41,1.9,4.72,4.72,0,0,1-5-4.73c0-4,3.6-5.93,9-5.89v-.22c0-.82-.44-2-2.81-2a8.7,8.7,0,0,0-4.25,1.17L77.22,9.3a12.73,12.73,0,0,1,6-1.34C88.33,8,90,11,90,14.61V20a24.76,24.76,0,0,0,.22,3.75Zm-.57-7.28c-2.52,0-4.48.57-4.48,2.42a1.72,1.72,0,0,0,1.89,1.83,2.6,2.6,0,0,0,2.49-1.76,3.23,3.23,0,0,0,.1-.82Z",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("path", {
    d: "M95.32,1.33h4.79V23.7H95.32Z",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("path", {
    d: "M121.31,23.1a13.64,13.64,0,0,1-5.45.92c-7.34,0-11.1-4.58-11.1-10.63,0-7.24,5.17-11.27,11.6-11.27a12.63,12.63,0,0,1,5.23.94l-1,3.81a10.33,10.33,0,0,0-4-.78c-3.82,0-6.78,2.29-6.78,7,0,4.25,2.52,6.93,6.81,6.93a11.89,11.89,0,0,0,4-.69Z",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("path", {
    d: "M140.5,15.82c0,5.64-4,8.23-8.13,8.23-4.5,0-8-3-8-7.95S127.68,8,132.63,8A7.48,7.48,0,0,1,140.5,15.82ZM129.35,16c0,2.64,1.1,4.63,3.15,4.63,1.86,0,3.06-1.86,3.06-4.63,0-2.3-.89-4.63-3.06-4.63S129.35,13.69,129.35,16Z",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("path", {
    d: "M145,13.21c0-1.93-.06-3.56-.12-4.92h4.15l.22,2.12h.1A5.65,5.65,0,0,1,154.15,8c3.15,0,5.51,2.08,5.51,6.62V23.7h-4.79V15.16c0-2-.69-3.34-2.42-3.34A2.54,2.54,0,0,0,150,13.61a3.31,3.31,0,0,0-.19,1.2V23.7H145Z",
    style: {
      "fill": "#345670"
    }
  }), React.createElement("path", {
    d: "M65.32,33.37c-.07-1.4-.16-3.08-.14-4.34h-.05c-.34,1.18-.76,2.43-1.27,3.82l-1.77,4.88h-1l-1.63-4.79c-.48-1.42-.88-2.72-1.16-3.91h0c0,1.26-.1,2.94-.19,4.45l-.27,4.31H56.58l.71-10h1.64l1.71,4.86c.41,1.23.76,2.34,1,3.38h0c.25-1,.61-2.12,1.06-3.38l1.79-4.86h1.63l.63,10.05H65.54Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M69.39,27.74v5.95c0,2.25,1,3.2,2.35,3.2s2.45-1,2.45-3.2V27.74H75.5V33.6c0,3.08-1.64,4.35-3.8,4.35s-3.61-1.18-3.61-4.3V27.74Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M78.91,28.83H75.85V27.74h7.44v1.09H80.21v9H78.89Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M85,27.74v5.95c0,2.25,1,3.2,2.34,3.2,1.5,0,2.46-1,2.46-3.2V27.74h1.31V33.6c0,3.08-1.64,4.35-3.8,4.35s-3.61-1.18-3.61-4.3V27.74Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M93.69,34.62l-1,3.17H91.3l3.42-10h1.56l3.43,10.05H98.32l-1.07-3.17Zm3.29-1-1-2.89c-.22-.66-.37-1.25-.52-1.84h0c-.15.6-.32,1.23-.51,1.82l-1,2.91Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M100.44,27.74h1.3v9H106v1.09h-5.59Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M117.62,33.37c-.08-1.4-.17-3.08-.15-4.34h0c-.34,1.18-.76,2.43-1.26,3.82l-1.78,4.88h-1l-1.64-4.79c-.47-1.42-.88-2.72-1.17-3.91h0c0,1.26-.1,2.94-.19,4.45l-.27,4.31h-1.23l.7-10h1.66l1.69,4.86c.41,1.23.76,2.34,1,3.38h0c.26-1,.61-2.12,1.06-3.38l1.79-4.86h1.64l.62,10.05h-1.26Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M129,32.66c0,3.46-2.1,5.29-4.66,5.29s-4.53-2.05-4.53-5.1,2-5.28,4.67-5.28S129,29.68,129,32.66Zm-7.8.16c0,2.15,1.17,4.09,3.21,4.09s3.22-1.89,3.22-4.17c0-2-1-4.09-3.21-4.09S121.18,30.61,121.18,32.82Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M129.92,27.87a13.88,13.88,0,0,1,2.49-.21,4.15,4.15,0,0,1,2.91.82,2.54,2.54,0,0,1,.79,1.91A2.62,2.62,0,0,1,134.22,33v0a2.54,2.54,0,0,1,1.48,2,16.26,16.26,0,0,0,.77,2.75h-1.35a13.34,13.34,0,0,1-.67-2.42c-.3-1.39-.82-1.91-2-2h-1.23v4.36h-1.29Zm1.3,4.58h1.32c1.39,0,2.27-.76,2.27-1.91s-.94-1.87-2.31-1.88a5.5,5.5,0,0,0-1.28.12Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M139.24,28.83h-3.06V27.74h7.45v1.09h-3.07v9h-1.31Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M151.25,37.34a9.62,9.62,0,0,1-3.09.55A4.72,4.72,0,0,1,143,32.82c0-3,2.07-5.19,5.44-5.19a6.35,6.35,0,0,1,2.51.46l-.32,1.06a5.3,5.3,0,0,0-2.22-.43,3.75,3.75,0,0,0-4,4,3.7,3.7,0,0,0,3.88,4.06,4.25,4.25,0,0,0,1.73-.27v-3h-2v-1h3.31Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M154.11,34.62l-1.06,3.17H151.7l3.42-10h1.56l3.43,10.05h-1.38l-1.08-3.17Zm3.29-1-1-2.89c-.23-.66-.37-1.25-.53-1.84h0c-.15.6-.31,1.23-.51,1.82l-1,2.91Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M168.29,37.34a9.58,9.58,0,0,1-3.09.55A4.72,4.72,0,0,1,160,32.82c0-3,2.07-5.19,5.45-5.19a6.3,6.3,0,0,1,2.5.46l-.31,1.06a5.31,5.31,0,0,0-2.23-.43,3.75,3.75,0,0,0-4,4c0,2.52,1.53,4.06,3.87,4.06a4.25,4.25,0,0,0,1.73-.27v-3h-2v-1h3.31Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M174.74,33.07h-3.91V36.7h4.35v1.09h-5.65v-10H175v1.09h-4.13V32h3.92Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M177.24,37.86v-3h.4l1,1.53a9.49,9.49,0,0,1,.54,1h0c0-.41,0-.77,0-1.23V34.85h.37v3h-.41l-1-1.54a10,10,0,0,1-.51-1h0c0,.38,0,.75,0,1.25v1.3Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M182.51,36.53c0-.41,0-.93,0-1.31h0c-.11.36-.23.73-.39,1.15l-.53,1.47h-.3l-.49-1.45c-.14-.41-.26-.82-.35-1.18h0c0,.38,0,.89-.06,1.35l-.08,1.3h-.37l.21-3h.5l.52,1.47c.12.37.23.7.3,1h0c.08-.3.19-.64.32-1l.54-1.47h.51l.18,3h-.38Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M183.37,34.83h.4v2.7h1.3v.33h-1.69Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M185.21,37.39a1.41,1.41,0,0,0,.7.19c.41,0,.64-.21.64-.51s-.16-.45-.57-.61-.82-.41-.82-.86a.87.87,0,0,1,.92-.82h.06a1.56,1.56,0,0,1,.67.15l-.11.32a1.26,1.26,0,0,0-.57-.14c-.41,0-.58.25-.58.45s.19.41.61.59.77.44.77.89-.34.87-1.06.87a1.47,1.47,0,0,1-.77-.19Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M187.33,37.86l.12-.88h-.37v-.27h.41l.08-.65h-.38v-.27h.41l.12-.86H188l-.1.86h.47l.12-.86h.26l-.11.86H189v.27h-.41l-.08.65h.39V37h-.41l-.12.89h-.27l.12-.89h-.47l-.11.89Zm.91-1.15.09-.65h-.5l-.08.65Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M191.1,37.86v-.79h-1.35V36.8l1.3-1.87h.43v1.83h.41v.31h-.41v.79Zm0-1.1V35.33h0l-.24.44-.71,1h.95Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M193.62,35.22h-.3a1.18,1.18,0,0,0-1,1h0a.88.88,0,0,1,1.25-.14.91.91,0,0,1,.34.75,1,1,0,0,1-.93,1h-.05c-.62,0-1-.49-1-1.23a1.84,1.84,0,0,1,.49-1.32,1.6,1.6,0,0,1,.94-.43l.29,0Zm-.12,1.68a.59.59,0,0,0-.51-.66h-.09a.67.67,0,0,0-.57.38.25.25,0,0,0,0,.17c0,.49.23.82.64.82s.57-.28.57-.7Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M194.12,37.43a1.36,1.36,0,0,0,.65.19c.51,0,.67-.33.66-.57,0-.41-.37-.59-.75-.59h-.22v-.3h.22c.28,0,.65-.14.65-.49s-.15-.44-.51-.44a1,1,0,0,0-.59.19l-.1-.29a1.37,1.37,0,0,1,.76-.22c.58,0,.82.34.82.7a.72.72,0,0,1-.51.66h0a.77.77,0,0,1,.65.76c0,.47-.36.88-1.07.88a1.57,1.57,0,0,1-.76-.2Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M198,34.93v.27l-1.27,2.66h-.41l1.27-2.59h-1.43v-.33Z",
    style: {
      "fill": "#6b6b6a"
    }
  }), React.createElement("path", {
    d: "M199.94,35.27h-1.11l-.11.75H199a1.26,1.26,0,0,1,.63.16.82.82,0,0,1,.41.75,1,1,0,0,1-1,1h-.07a1.37,1.37,0,0,1-.73-.18l.1-.3a1.38,1.38,0,0,0,.63.17.66.66,0,0,0,.69-.6v0c0-.38-.25-.65-.84-.65a2.83,2.83,0,0,0-.41,0l.19-1.4h1.4Z",
    style: {
      "fill": "#6b6b6a"
    }
  }));
};

export default __webpack_public_path__ + "static/media/calcon-logo-color.6a545afd.svg";
export { SvgComponent as ReactComponent };